import React, { useEffect, useState } from "react";
import {
  listCategories,
  createCategory,
  deleteCategory,
  uploadCatalogImage,
} from "./productsService";

export default function CategoryManager() {
  const [categories, setCategories] = useState([]);
  const [name, setName] = useState("");
  const [imageFile, setImageFile] = useState(null);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState(null);

  const refresh = async () => {
    const list = await listCategories();
    setCategories(list);
  };

  useEffect(() => {
    refresh();
  }, []);

  const handleAdd = async (e) => {
    e.preventDefault();
    if (!name.trim()) return;
    setSaving(true);
    setError(null);
    try {
      const imageUrl = imageFile ? await uploadCatalogImage(imageFile, "category-images") : null;
      await createCategory({ name: name.trim(), image: imageUrl, order: categories.length });
      setName("");
      setImageFile(null);
      await refresh();
    } catch (err) {
      setError(err.message);
    } finally {
      setSaving(false);
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Delete this category? Products already assigned to it will keep their category ID but won't show a tab for it.")) return;
    await deleteCategory(id);
    await refresh();
  };

  return (
    <div className="admin-panel">
      <h3>Categories</h3>

      <div className="admin-category-list">
        {categories.map((cat) => (
          <div className="admin-category-chip" key={cat.id}>
            {cat.image && <img src={cat.image} alt={cat.name} />}
            <span>{cat.name}</span>
            <button type="button" onClick={() => handleDelete(cat.id)} aria-label={`Delete ${cat.name}`}>
              ×
            </button>
          </div>
        ))}
      </div>

      <form onSubmit={handleAdd} className="admin-inline-form">
        <input
          type="text"
          placeholder="Category name (e.g. Clothing, Jewelry, Subscriptions)"
          value={name}
          onChange={(e) => setName(e.target.value)}
        />
        <input
          type="file"
          accept="image/*"
          onChange={(e) => setImageFile(e.target.files?.[0] || null)}
        />
        <button type="submit" disabled={saving}>
          {saving ? "Adding…" : "Add Category"}
        </button>
      </form>
      {error && <p className="admin-error">{error}</p>}
    </div>
  );
}
